import { DispatchLeg } from '@api/Trinium/Endpoints/Dispatch/types';
import { defaultSortComparator } from '@components/DataGrid/types';
import { applyColumnQuickFilter, caseInsensitiveIncludes } from '../columns';
import RenderHeader from '@components/DataGrid/RenderHeader';
import RenderCell from '@components/DataGrid/RenderCell';
import { GridColDefExtended } from '@mui/x-data-grid-pro';

const headerDisplayName = 'Trc Evt. State';

const traceEventStateDefinition: GridColDefExtended<DispatchLeg> = {
	field: 'Trc Evt State',
	minWidth: 120,
	width: 120,
	headerName: 'Trc Evt State',
	headerDisplayName,
	renderHeader: () => <RenderHeader primaryText={headerDisplayName} />,
	renderCell: ({ row }) => <RenderCell primarySlot={<span title={row.trcEventState}>{row.trcEventState}</span>} />,
	disableReorder: true,
	getApplyQuickFilterFn: (value: string) => {
		return (_, row): boolean =>
			applyColumnQuickFilter(value, row, (value: string, row: DispatchLeg) => {
				const { trcEventState } = row;
				return caseInsensitiveIncludes(value, [trcEventState]);
			});
	},
	valueGetter: (_, row: DispatchLeg) => row.trcEventState?.replaceAll(',', ''),
	sortable: true,
	sortComparator: defaultSortComparator
};

export default traceEventStateDefinition;
